<div
  class="sonder-form-legend"
  [ngClass]="classToggles"
  data-test="documents-form-section"
>
  <div class="-title">
    <ng-content></ng-content>
  </div>
  <div class="-subtitles">
    <ng-content select="p,ul,ol"></ng-content>
  </div>
</div>
